<template>
    <div class="panel-footer">
        {{ footerText }}
        <a
            href="https://www.voicemod.net/?utm_source=TWITCHEXT&utm_medium=PLUGIN&utm_campaign=VOICEMODCLIPS"
            target="_blank"
        >Voicemod<sup>&reg;</sup>
        </a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            footerText: this.$t('twitch.globalMsg.powered'),
        };
    },
};
</script>

<style src="./PanelFooter.scss" lang="scss" scoped></style>
